export default () => {

  const s = {}
  const init = () => {
    const mediaPromise = new Promise (resolve => {
      s.root = document.querySelector('.c-splash');

      // kvに使用されているvideo要素の抽出
      s.medias = [].map.call(document.querySelectorAll('video'), video => video)
        .filter(video => video.classList.contains('hm-kv__video-entity'));
      // mediaの読み込み状態を取得
      s.mediaPromises = getMediaPromises();

      // 全てのmediaの読み込みを待ってsplashの非表示
      Promise.all(s.mediaPromises)
        .then(() => {
          console.log('mediaload')
          s.root.classList.add('is-hidden');
          resolve();
        })
    })

    return [
      mediaPromise
    ]
  }

  const getMediaPromises = () => {
    console.log('getMediaPromises');
    return s.medias.map(media => {
      return new Promise(resolve => {
        const nodeName = media.nodeName.toLowerCase();

        if (nodeName == 'video') {
          media.isResolve = false;

          media.addEventListener('loadeddata', () => {
            console.log('loadeddata', media);
            resolve();
            media.isResolve = true;
          })

          const intervalId = setInterval(() => {
            console.log(media.readyState)
            if (media.readyState == 4 || media.isResolve) {
              clearInterval(intervalId);
              resolve();
            }
          }, 100);

        } else {
          resolve();
        }
      })
    })
  }

  s.promises = init();

  // mediaの処理状態を外部に通知
  return Promise.all(s.promises);
}
